export const termsOfUseHtml = `
<p><strong>Effective Date:</strong> December 19, 2025<br>
<strong>Last Updated:</strong> December 19, 2025</p >

<p>Welcome to Miracle Pace Inc. (“Miracle Pace”, “we”, “our”, or “us”). These Terms of Use (“Terms”) govern your access to and use of our website, mobile applications, and related financial services (collectively, the “Platform”).  
By accessing or using the Platform, you agree to these Terms. If you do not agree, do not use the Platform.</p >

<h2>1. Introduction</h2>
<p>Miracle Pace provides currency exchange and payment-related services. These Terms outline your rights, responsibilities, and obligations while using our Platform.</p >

<h2>2. Eligibility</h2>
<p>You must:</p >
<ul>
<li>Be at least 18 years old (or the age of majority in your jurisdiction)</li>
<li>Have legal capacity to enter into binding agreements</li>
<li>Use the Platform only for lawful purposes and in compliance with applicable laws</li>
</ul>

<h2>3. Account Registration</h2>
<p>You may need to create an account to access certain features. You agree to:</p >
<ul>
<li>Provide accurate and truthful information</li>
<li>Maintain confidentiality of your login credentials</li>
<li>Notify Miracle Pace immediately of unauthorized use</li>
</ul>

<h2>4. User Responsibilities</h2>
<p>You agree not to:</p >
<ul>
<li>Engage in fraudulent, illegal, or abusive activity</li>
<li>Interfere with Platform operation</li>
<li>Access data not intended for you</li>
<li>Use automated tools without written permission</li>
<li>Violate any applicable laws or regulations</li>
</ul>

<h2>5. Our Services</h2>
<p>Miracle Pace provides currency exchange, transfer services, and related financial tools. We reserve the right to update, suspend, or discontinue any aspect of our Services without notice.</p >
<p><strong>Important Disclaimer:</strong> Miracle Pace provides a platform for currency exchange and payment-related services as a conduit between users and third-party exchange providers. Miracle Pace does <strong>not</strong> guarantee any transaction results and does <strong>not</strong> assume any responsibility or liability for transactions conducted through the platform.</p >

<h2>6. Platform Fees</h2>
<p>Miracle Pace services are <strong>completely free</strong>. There are <strong>no platform fees</strong> charged to users.</p >

<h2>7. Stripe & Third-Party Fees</h2>
<p>Payments are processed by third-party providers (e.g., Stripe).</p >
<ul>
<li>Any fees charged by Stripe are <strong>paid directly by the user</strong>.</li>
<li>Miracle Pace does <strong>not</strong> mark up, modify, or retain these fees.</li>
<li>Fees will be disclosed prior to transaction confirmation.</li>
</ul>
<p><strong>Transaction Confirmation Notice:</strong>  
“Miracle Pace does not charge platform fees. Stripe processing fees are paid by you. The final amount may vary slightly due to exchange rate changes and third-party processing.”</p >

<h2>8. Exchange Rates & Settlement</h2>
<ul>
<li>Displayed rates are for reference; final settlement may vary due to market fluctuations or adjustments.</li>
<li>Users acknowledge that final amounts may differ slightly from initially displayed rates.</li>
<li>Miracle Pace is not responsible for differences arising from market volatility or third-party processing.</li>
</ul>

<h2>9. Third-Party Services</h2>
<p>Miracle Pace may integrate with third-party providers (Stripe, AWS, etc.). These providers may access necessary data to perform their services. Miracle Pace is not responsible for third-party actions, failures, or fees.</p >

<h2>10. Data Privacy</h2>
<p>We handle data in accordance with our Privacy Policy. By using the Platform, you consent to data collection, use, and disclosure as described in our Privacy Policy.</p >

<h2>11. Intellectual Property</h2>
<p>All content, branding, software, and materials are owned by Miracle Pace or its licensors. No reproduction or use is allowed without written permission.</p >

<h2>12. Limitation of Liability</h2>
<p>To the fullest extent permitted by law, Miracle Pace is not liable for indirect, incidental, or consequential damages. Maximum liability is limited to payments made by you in the previous 12 months (which may be zero).</p >

<h2>13. Disclaimer of Warranties</h2>
<p>The Platform is provided “as is” and “as available” without warranties of any kind.</p >

<h2>14. Indemnification</h2>
<p>You agree to indemnify and hold harmless Miracle Pace, its officers, employees, and affiliates from claims arising out of your misuse of the Platform or violation of these Terms.</p >

<h2>15. Termination</h2>
<p>Miracle Pace may suspend or terminate your account at any time. Upon termination, all rights to access or use the Platform cease immediately.</p >

<h2>16. Governing Law & Dispute Resolution</h2>
<p>These Terms are governed by the laws of Ontario, Canada. All disputes will be resolved exclusively in the courts of Toronto, Ontario.</p >

<h2>17. Changes to Terms & Contact</h2>
<ul>
<li>We may update these Terms at any time; updates will be posted on the Platform.</li>
<li>Continued use of the Platform constitutes acceptance of updated Terms.</li>
<li>Contact: Miracle Pace Inc., 1200 Bay Street, Suite 1201, Toronto, Ontario, Canada, Email: <strong>miraclepaceinc@outlook.com</strong></li>
</ul>
`;
